<template>
  <div class="animated fadeIn ventas-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="2"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  :state="clienteValido"
                  readonly
                  type="text"/>
                <b-form-invalid-feedback id="clienteFeedback">
                  {{ clienteInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Fecha Comp."
              label-for="fechaComprobante"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="fechaComprobante" 
                v-model="fechaComprobante" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Venc."
              label-for="fechaVencimiento"
              :label-cols="2"
              :description="plazoPago"
              horizontal>
              <b-form-input 
                id="fechaVencimiento" 
                v-model="fechaVencimiento" 
                type="date">
              </b-form-input>
            </b-form-group>

            <div v-if="formularioVisible" class="grupo-controles">
              <b-form-group
                label="Comprobante"
                :label-cols="2"
                horizontal>
                <b-form-select 
                  id="comprobanteTipo"
                  v-model="comprobanteTipoNombre" 
                  :state="comprobanteTipoValido"
                  :options="comprobantesTiposList" 
                  class="mb-3">
                  <template slot="first">
                    <option :value="null" disabled>Seleccione el tipo de comprobante</option>
                  </template>
                </b-form-select>                 
                <b-form-input 
                  id="formulario"
                  v-model.trim="$v.formulario.$model" 
                  :state="formularioValido"
                  :formatter="inputFormatFormulario"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-invalid-feedback id="comprobanteTipoFeedback">
                  {{ comprobanteTipoInvalidoMsj }}
                </b-form-invalid-feedback>          
                <b-form-invalid-feedback id="formularioFeedback">
                  {{ formularioInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-form-group>
            </div>
            
            <b-form-group
              v-if="!formularioVisible"
              label="Comprobante"
              :label-cols="2"
              horizontal>
              <b-form-select 
                id="comprobanteTipo"
                v-model="comprobanteTipoNombre" 
                :state="comprobanteTipoValido"
                :options="comprobantesTiposList" 
                class="mb-3">
                <template slot="first">
                  <option :value="null" disabled>Seleccione el tipo de comprobante</option>
                </template>
              </b-form-select>                 
              <b-form-invalid-feedback id="comprobanteTipoFeedback">
                {{ comprobanteTipoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <div v-if="puntoVentaVisible" class="grupo-controles">
              <b-form-group
                label="Número"
                label-for="numero"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="numeroPuntoVenta"
                  v-model.trim="$v.numeroPuntoVenta.$model" 
                  :state="numeroPuntoVentaValido"
                  type="number"
                  min="0000" max="9999"
                  @blur.native="validate">
                </b-form-input>
                <b-form-input 
                  id="numero"
                  v-model.trim="$v.numero.$model" 
                  :state="numeroValido"
                  type="number"
                  @blur.native="validate">
                </b-form-input>
                <b-form-invalid-feedback id="numeroPuntoVentaFeedback">
                  {{ numeroPuntoVentaInvalidoMsj }}
                </b-form-invalid-feedback>          
                <b-form-invalid-feedback id="numeroFeedback">
                  {{ numeroInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-form-group>
            </div>

            <b-form-group
              v-if="!puntoVentaVisible"
              label="Número"
              label-for="numero"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="numero"
                v-model.trim="$v.numero.$model" 
                :state="numeroValido"
                :disabled="numeroDisabled"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Moneda"
              label-for="moneda"
              :label-cols="2"
              horizontal>
              <b-form-select 
                v-model="monedaNombre" 
                :options="monedasList" 
                class="mb-3">
                <template slot="first">
                  <option :value="null" disabled>Seleccione una moneda</option>
                </template>
              </b-form-select>
            </b-form-group>

            <!-- <b-form-group
              label="Moneda"
              label-for="moneda"
              :label-cols="2"
              horizontal>
              <b-form-select 
                v-model="monedaNombre" 
                :options="monedasList" 
                disabled
                class="mb-3">
                <template slot="first">
                  <option :value="null" disabled>Seleccione una moneda</option>
                </template>
              </b-form-select>
            </b-form-group> -->

            <b-form-group
              label="Cotización"
              label-for="cotizacion"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="cotizacion"
                v-model.trim= "$v.cotizacion.$model" 
                :state="cotizacionValido"
                type="text"
                @blur.native="validate"
                :readonly="cotizacionReadOnly">
              </b-form-input>
              <b-form-invalid-feedback id="cotizacionFeedback">
                {{ cotizacionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Moneda Pago"
              label-for="monedaPago"
              :label-cols="2"
              horizontal>
              <b-form-select 
                v-model="monedaPagoNombre" 
                :options="monedasList" 
                class="mb-3"
                :disabled="monedaPagoReadOnly">
                <template slot="first">
                  <option :value="null" disabled>Seleccione una moneda</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              v-if="opcionesFCEMyPime"
              :label-cols="2"
              label-for="sistemaCirculacionAbierta"
              description="Por defecto la opción es Agente de Depósito Colectivo"
              horizontal>
              <b-form-checkbox 
                  id="sistemaCirculacionAbierta"
                  v-model="sistemaCirculacionAbierta"
                  value= true
                  unchecked-value= false>
                  Sistema de Circulación Abierta (FCE MiPyME)
              </b-form-checkbox>
            </b-form-group>
          </b-card>

          <b-card>
            <b-row>
              <b-col class="certificados-seleccionar-todo">
                <label class="text-muted">Seleccionar todos / eliminar selección</label>
                <b-form-checkbox
                    v-model="estadoCertificadosSeleccionados" 
                    :indeterminate.sync="estadoCertificadosSeleccionadosIndeterminado"
                    @click.native.prevent="actualizarSeleccion">
                  <!-- Seleccionar todos / eliminar selección -->
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes renglones-certificados" 
                :busy="tableBusy"
                :items="renglones"
                :fields="fields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(fechaRegistro)="data">
                {{ data.item.fechaRegistro | fecha }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda(data.item.moneda) }}
              </template>
              <template v-slot:cell(seleccionado)="data">
                <b-form-checkbox 
                    v-model="data.item.seleccionado"
                    :disabled="data.item.seleccionDisabled"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)"
                    @click.native.prevent="seleccionarRenglon(data.item)">
                </b-form-checkbox> 
              </template>
            </b-table>
          </b-card>

          <b-card>
            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="2"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Monto Total"
              label-for="total"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="total"
                :value="total | moneda(monedaNombre)"
                readonly>
              </b-form-input>
            </b-form-group>

            <!-- <b-form-group
              label="Monto Total"
              label-for="montoTotal"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="montoTotal"
                :value="montoTotal | moneda(monedaNombre)"
                readonly>
              </b-form-input>
            </b-form-group> -->
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    
    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import { required, requiredIf, numeric, decimal, minValue, maxValue, maxLength } from 'vuelidate/lib/validators';
import SearchCliente from '../clientes/SearchList.vue'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'venta/getField',
  mutationType: 'venta/updateField',
});

export default {
  name: 'ABM',
  components: {
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      comprobanteTipoValido: null,
      comprobanteTipoInvalidoMsj: '',
      formularioValido: null,
      formularioInvalidoMsj: '',
      cotizacionValido: null,
      cotizacionInvalidoMsj: '',
      numeroPuntoVentaValido: null,
      numeroPuntoVentaInvalidoMsj: '',
      numeroValido: null,
      numeroInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      fields: [
        {
            key: 'id',
            label: 'Nro.Certificado',
            sortable: true
        },
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        {
            key: 'accion',
        },
        {
            key: 'numeroOrdenCompra',
            label: 'Nro.PO',
            sortable: true
        },
        /*
        { key: 'cotizacion', class: "text-right" },
        { key: 'saldo', class: "text-right" },
        */
        { key: 'importe', class: "text-right" },
        { 
          key: 'seleccionado', 
          label: '',
          class: "text-center" 
        },
      ],

      tableBusy: false,
      cotizacionReadOnly: true,
      monedaPagoReadOnly: true,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'cliente',
      'clienteNombre',
      'clientePlazoPago',
      'fechaComprobante',
      'fechaVencimiento',
      'comprobanteTipo',
      'comprobanteTipoNombre',
      'formulario',
      'numeroPuntoVenta',
      'numero',
      'sistemaCirculacionAbierta',
      'moneda',
      'monedaNombre',
      'cotizacion',
      'renglones',
      'total',
      'montoGravado',
      'montoNoGravado',
      'montoIvaInscripto',
      'montoExento',
      'monedaPago',
      'monedaPagoNombre',

      'observaciones',

      'certificadosSeleccionados',
      'certificadosSeleccionadosIndeterminado',

      'monedas',
      'monedasList',
      'comprobantesTipos',
      'comprobantesTiposList',
      'opcionesFCEMyPime',

      'montoNoGravadoVisible',
      'formularioVisible',
      'puntoVentaVisible'
    ]),
    montoTotal() {
      let montoGravado = 0;
      let montoNoGravado = 0;
      let montoIvaInscripto = 0;
      let montoExento = 0;

      if (this.montoGravado) {
        if (!isNaN(this.montoGravado)) {
          montoGravado = parseFloat(this.montoGravado);
        }
      }
      if (this.montoNoGravado) {
        if (!isNaN(this.montoNoGravado)) {
          montoNoGravado = parseFloat(this.montoNoGravado);
        }
      }
      if (this.montoIvaInscripto) {
        if (!isNaN(this.montoIvaInscripto)) {
          montoIvaInscripto = parseFloat(this.montoIvaInscripto);
        }
      }
      if (this.montoExento) {
        if (!isNaN(this.montoExento)) {
          montoExento = parseFloat(this.montoExento);
        }
      }

      return montoGravado + montoNoGravado + montoIvaInscripto + montoExento;
    },
    estadoCertificadosSeleccionados: {
      get: function () {
        return this.certificadosSeleccionados;
      },
      set: function (newValue) {
      }
    },
    estadoCertificadosSeleccionadosIndeterminado: {
      get: function () {
        return this.certificadosSeleccionadosIndeterminado;
      },
      set: function (newValue) {
      }
    },
    plazoPago() {
      if (this.clientePlazoPago) {
        if (this.clientePlazoPago != 0) {
          return `Plazo de Pago: ${this.clientePlazoPago.toString().trim()} días`;
        }
      }
      return '';
    },
    numeroDisabled() {
      if (this.comprobanteTipo) {
        return (/true/i).test(this.comprobanteTipo.numeracionAutomatica);
      }

      return false;
    }
  },  
  activated() {
    this.getDatosAdicionales();
  },
  methods: {
    getDatosAdicionales() {
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'formulario' || validarTodos) {
        if (this.$v.formulario.$error) {
          this.formularioValido = false;
          if (!this.$v.formulario.required) {
            this.formularioInvalidoMsj = 'Debe ingresar el formulario correspondiente.';
          }     
        } else {
          this.formularioValido = null;
          this.formularioInvalidoMsj = '';
        }
      }

      if (campo == 'numeroPuntoVenta' || validarTodos) {
        if (this.$v.numeroPuntoVenta.$error) {
          this.numeroPuntoVentaValido = false;
          if (!this.$v.numeroPuntoVenta.required) {
            this.numeroPuntoVentaInvalidoMsj = 'Debe ingresar el número de punto de venta.';
          } else if (!this.$v.numeroPuntoVenta.numeric || !this.$v.numeroPuntoVenta.minValue || !this.$v.numeroPuntoVenta.maxValue) {
            this.numeroPuntoVentaInvalidoMsj = 'El número de punto de venta ingresado no es válido.';
          }     
        } else {
          this.numeroPuntoVentaValido = null;
          this.numeroPuntoVentaInvalidoMsj = '';
        }
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
          if (!this.$v.numero.numeric || !this.$v.numero.minValue || !this.$v.numero.maxValue) {
            this.numeroInvalidoMsj = 'El número de comprobante ingresado no es válido.';
          }    
        } else {
          this.numeroValido = null;
          this.numeroInvalidoMsj = '';
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 500 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    seleccionarRenglon(item) {
      if (!item.seleccionDisabled) {
        item.seleccionado = !item.seleccionado;
        /* Actualizamos totales y el estado del check global */
        this.$store.dispatch('venta/certificadoSeleccionado');
      }
    },
    actualizarSeleccion() {
      this.$store.dispatch('venta/actualizarSeleccionCertificados');
    },
    seleccionarCliente() {
      this.$refs.searchClienteModal.show()
    },
    clienteSeleccionado(item) {
      this.$refs.searchClienteModal.hide();
      this.tableBusy = true;
      this.$store.dispatch('venta/setCliente', item)
        .then (() => {
          this.tableBusy = false;
          this.clienteValido = null;
          this.clienteInvalidoMsj = '';
          this.validarComprobante();
        });
    },
    validarComprobante() {
      // console.log('validarComprobante');
      // console.log('noValidar', this.noValidar);

      // if (this.noValidar) {
      //   this.$emit('can-continue', { value: false });
      //   return;
      // }

      this.$v.$touch();

      let save = Boolean(true);

      let clienteError = true;
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            clienteError = false;
          }
        }
      }
      if (clienteError) {
        save = Boolean(false);
        // this.clienteValido = false;
        // this.clienteInvalidoMsj = "Debe seleccionar el cliente correspondiente.";
      }

      let comprobanteTipoError = true;
      if (this.comprobanteTipo) {
        if (this.comprobanteTipo.id) {
          if (this.cliente.id != 0) {
            comprobanteTipoError = false;
          }
        }
      }
      if (comprobanteTipoError) {
        save = Boolean(false);
        // this.clienteValido = false;
        // this.clienteInvalidoMsj = "Debe seleccionar el cliente correspondiente.";
      }

      // let comprobanteTipo;
      // if (this.comprobanteTipoNombre) {
      //   comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
      // }

      // let comprobanteTipoError = true;
      // if (this.comprobanteTipo) {
      //   if (this.comprobanteTipo.id) {
      //     if (this.comprobanteTipo.id != comprobanteTipo.id) {
      //       if (comprobanteTipo) {
      //         if (comprobanteTipo.id) {
      //           if (comprobanteTipo.id != 0) {
      //             comprobanteTipoError = false;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }

      // if (comprobanteTipoError) {
      //   save = Boolean(false);
      //     // this.comprobanteTipoValido = false;
      //     // this.comprobanteTipoInvalidoMsj = "Debe seleccionar el tipo de comprobante correspondiente.";
      // } else {
      //   this.$store.dispatch('venta/setComprobanteTipo', comprobanteTipo);
      // }

      if (save) {
        if (!this.$v.$anyError) {
          this.$emit('can-continue', { value: true });
        } else {
          this.displayErrores();
          this.$emit('can-continue', { value: false });
        }
      } else {
          this.$emit('can-continue', { value: false });
      }
    }
  },
  validations: {
    formulario: {
      // required
      required: requiredIf(function () {
        return this.formularioVisible;
      }),
    },
    numeroPuntoVenta: {
      // required,
      required: requiredIf(function () {
        return this.puntoVentaVisible;
      }),
      numeric,
      minValue: minValue(0),
      maxValue: maxValue(9999)
    },
    numero: {
      numeric,
      minValue: minValue(0),
      maxValue: maxValue(99999999)
    },
    cotizacion: { 
      decimal, 
      minValue: minValue(0) 
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
    'fechaComprobante' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.dispatch('venta/calcularFechaVencimiento');
      }
    },
    'comprobanteTipoNombre' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        let comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
        
        /* Actualizamos la información del tipo de comprobante */
        this.$store.dispatch('venta/setComprobanteTipo', comprobanteTipo);

        this.comprobanteTipoValido = null;
        this.comprobanteTipoInvalidoMsj = '';

        this.validarComprobante();
      }
    },
    'formulario' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.validarComprobante();
      }
    },
    'numeroPuntoVenta' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.noValidar = false;
        this.validarComprobante();
      }
    },
    'numero' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.noValidar = false;
        this.validarComprobante();
      }
    },
    'monedaNombre' : function(newVal, oldVal) {
      for ( let key in this.monedas ){
        const moneda = this.monedas[key]
        if (moneda.nombre.trim() == newVal.trim() ){
          
          this.$store.dispatch('venta/setMoneda', moneda);

          if (moneda.id == 101) {
            this.cotizacionReadOnly = true;
            this.cotizacion = 1;
            this.monedaPagoReadOnly = true;
          } else {
            this.cotizacionReadOnly = false;
            this.monedaPagoReadOnly = false;
          }

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    'monedaPagoNombre' : function(newVal, oldVal) {
      for ( let key in this.monedas ){
        const moneda = this.monedas[key]
        if (moneda.nombre.trim() == newVal.trim() ){
          
          this.$store.dispatch('venta/setMonedaPago', moneda);

          // this.monedaValida = null;
          // this.monedaInvalidaMsj = '';
        }
      }
    },

    // 'total' : function(newVal, oldVal) {
    //   this.$store.dispatch('venta/calcularMontosTotal')
    // },
    'cotizacion' : function(newVal, oldVal) {
      this.$store.dispatch('venta/calcularTotales')
    },
  }    
}
</script>

<style>
  .certificados-seleccionar-todo {
    display: inline-block;
    text-align: right;
    margin-bottom: 10px;
    padding-right: 30px;
  }
  .certificados-seleccionar-todo label {
    display: inline-block;
    font-size: 12px;
  }
  .certificados-seleccionar-todo .custom-checkbox {
    display: inline-block;
    width: 40px;
  }

  .ventas-abm .renglones-certificados table tr.table-danger,
  .ventas-abm .renglones-certificados table tr.table-danger td {
    background-color: transparent;
    /* color: var(--danger); */
    color: #bcbcbc;
    border-color: #c8ced3;
  }
  /* .ventas-abm .renglones-certificados table tr.table-danger td input {
    border-bottom: 1px solid var(--danger);
  } */

</style>
